// extracted by mini-css-extract-plugin
export default {"open":"appbar_open__0DY3D","close":"appbar_close__LLfj+"};